import { CUSTOMER_TABS, DASHBOARD_TASKS, DASHBOARD_TILES, defineModule } from "@motolynk/app-core";

import { CustomerOrdersTab } from "./admin/CustomerOrdersTab";
import { OrdersTile, SalesTile } from "./admin/dashboard";
import { AdminOrderTasks, VendorOrderTasks, VendorOrdersTab } from "./tasks";
import { StoreEarningsTile, StoreOrdersTile, StoreSalesTile } from "./vendor/dashboard";

import en from "./i18n/en.json";

export const ordersModule = defineModule({
  name: "orders",
  label: "Orders",
  requires: [
    "core",
    "geo",
    "accounts",
    "configuration",
    "audit",
    "notifications",
    "vehicles",
    "taxes",
    "catalog",
    "vendors",
    "products",
    "logistics",
    "cart",
    "payments",
    "payouts",
  ],
  i18n: { en },
  // Checkout and the customer's own order pages serve the storefront; the panels manage orders (P5-01, P5-02).
  admin: {
    routes: [
      { path: "orders", permission: "orders.view_order", page: () => import("./admin/OrdersPage") },
      {
        path: "orders/:number",
        permission: "orders.view_order",
        page: () => import("./admin/OrderPage"),
      },
    ],
    nav: [
      {
        id: "orders",
        group: "business",
        label: "orders:nav.orders",
        icon: "inbox",
        to: "/orders",
        permission: "orders.view_order",
        order: 1,
      },
    ],
    slots: {
      [DASHBOARD_TASKS]: [
        { id: "orders", permission: "orders.view_order", order: 5, component: AdminOrderTasks },
      ],
      // the vendors module's store page (well-known slot "vendor.tabs")
      "vendor.tabs": [
        {
          id: "orders",
          label: "orders:nav.orders",
          permission: "orders.view_order",
          component: VendorOrdersTab,
        },
      ],
      [CUSTOMER_TABS]: [
        {
          id: "orders",
          label: "orders:admin.customerTab.label",
          permission: "orders.view_order",
          component: CustomerOrdersTab,
        },
      ],
      [DASHBOARD_TILES]: [
        { id: "sales", permission: "orders.view_order", order: 10, component: SalesTile },
        { id: "orders", permission: "orders.view_order", order: 20, component: OrdersTile },
      ],
    },
  },
  // the store's own orders (team-role code `orders.manage`, ADR 0029): fulfilment, vendor steps 10-12 (P5-01)
  vendor: {
    routes: [
      { path: "orders", permission: "orders.manage", page: () => import("./vendor/OrdersPage") },
      {
        path: "orders/:number",
        permission: "orders.manage",
        page: () => import("./vendor/OrderPage"),
      },
    ],
    nav: [
      {
        id: "orders",
        group: "sales",
        label: "orders:nav.orders",
        icon: "inbox",
        to: "/orders",
        permission: "orders.manage",
        order: 10,
      },
    ],
    slots: {
      [DASHBOARD_TASKS]: [
        { id: "orders", permission: "orders.manage", order: 1, component: VendorOrderTasks },
      ],
      [DASHBOARD_TILES]: [
        { id: "sales", permission: "orders.manage", order: 1, component: StoreSalesTile },
        { id: "orders", permission: "orders.manage", order: 2, component: StoreOrdersTile },
        { id: "earnings", permission: "orders.manage", order: 90, component: StoreEarningsTile },
      ],
    },
  },
});
